import { axios } from '../../../utils/axios';
import { showAlert } from '../../../utils/alerts';

export const fetchCodes = async (id) => {
  try {
    const { data } = await axios.get(`/costing-request/pir-codes`);
    return data.data;
  } catch (e) {
    showAlert(e, 'error');
  }
};

export const fetchInfo = async (payload) => {
  try {
    const filteredPayload = payload
      .map((item) => {
        if (!item.sku || !item.buyer_country || !item.brewer_country) return;
        return {
          sku: item.sku,
          buyer_country: item.buyer_country,
          brewer_country: item.brewer_country,
        };
      })
      .filter((i) => i);
    const { data } = await axios.post(`/costing-request/pir-extension`, filteredPayload);
    return data.data;
  } catch (e) {
    showAlert(e, 'error');
  }
};

export const submitInfo = async (payload) => {
  try {
    const { data } = await axios.post(`/costing-request/pir-extension-submit`, payload);
    return data;
  } catch (e) {
    throw e;
  }
};

export const fetchById = async (id) => {
  try {
    const { data } = await axios.get(`/costing-request/pir/${id}`);
    return data.data;
  } catch (e) {
    showAlert(e, 'error');
  }
};
